import { z } from 'zod';
const phoneSchema = z
    .string()
    .trim()
    .min(4, 'Phone number is too short')
    .max(32, 'Phone number is too long')
    .refine((s) => /^[+0-9 ()-]+$/.test(s), 'Phone may only contain digits, +, -, spaces and parens');
const emailSchema = z.union([
    z.string().trim().email('Invalid email'),
    z.literal(''),
    z.null(),
]);
const customFieldsSchema = z.record(z.string(), z.unknown()).optional().nullable();
export const CreateCrmContactRequestSchema = z.object({
    name: z.string().trim().min(1, 'Name is required').max(200),
    phone: phoneSchema,
    email: emailSchema.optional(),
    company: z.union([z.string().trim().max(200), z.literal(''), z.null()]).optional(),
    notes: z.union([z.string().max(4000), z.null()]).optional(),
    tags: z.array(z.string().trim().min(1).max(40)).max(20).optional(),
    customFields: customFieldsSchema,
});
export const UpdateCrmContactRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(200).optional(),
    phone: phoneSchema.optional(),
    email: emailSchema.optional(),
    company: z.union([z.string().trim().max(200), z.literal(''), z.null()]).optional(),
    notes: z.union([z.string().max(4000), z.null()]).optional(),
    tags: z.array(z.string().trim().min(1).max(40)).max(20).optional(),
    customFields: customFieldsSchema,
})
    .refine((data) => Object.keys(data).length > 0, {
    message: 'At least one field must be provided',
});
export const ImportCrmContactsRequestSchema = z.object({
    contacts: z.array(CreateCrmContactRequestSchema).min(1).max(5000),
});
export const GrantCrmUserBodySchema = z.object({
    userId: z.string().uuid(),
});
// --- Sales pipeline (v2.8) — leads ---
export const CRM_LEAD_STAGE_VALUES = [
    'new',
    'contacted',
    'qualified',
    'proposal',
    'negotiation',
    'won',
    'lost',
];
export const ConvertContactToLeadRequestSchema = z.object({
    contactId: z.string().uuid(),
});
export const UpdateLeadStageRequestSchema = z.object({
    stage: z.enum(CRM_LEAD_STAGE_VALUES),
});
//# sourceMappingURL=crm.schema.js.map